(function () {
    'use strict';
    var m = angular.module('policy');
    m.factory('policyActions', ["$q", "objectTypeDao", "policyDao", "avananUserDao", "policyReportDao", "feature", "escapeHtml", "linkedText", "policyPropertyPathToId", "policyPropertyToNodes", "sideMenuManager", "uuid", "policyPropertyParser", "modals", "remediationProperties", "policyConditionToFiltersConverter", "actionTagsProcessor", "brandInfo", function ($q, objectTypeDao, policyDao, avananUserDao, policyReportDao, feature, escapeHtml, linkedText, policyPropertyPathToId, policyPropertyToNodes, sideMenuManager, uuid, policyPropertyParser, modals, remediationProperties, policyConditionToFiltersConverter, actionTagsProcessor, brandInfo) {
        var policyActions = {
            getActions: function (id) {
                var propertiesPromise = objectTypeDao.retrieve(false);
                return $q.all([
                    propertiesPromise,
                    policyDao.retrieve(id, propertiesPromise)
                ]);
            },
            generateSendMail: function (model, internalModel, tableModel, lastArgs) {
                var attributes = {};
                var policyName = model.name || 'No name policy';
                attributes.subject = brandInfo.getBrandLabel() + ' alert: ' + policyName;
                attributes.content = '';
                if (model.name) {
                    attributes.content = '<p class="top-alert-name">' + escapeHtml(model.name) + '</p>';
                }
                attributes.content += '<p>';
                attributes.content += 'Hello,<br />';
                attributes.content += brandInfo.getBrandLabel() + ' has just detected a security event.<br />';
                attributes.content += 'Please see below:';
                attributes.content += '</p>';
                attributes.content += '<h3>Event data</h3>';
                attributes.content += '<table><tbody>';
                _(model.columnsOrderOverride).each(function (columnId) {
                    var column;
                    if (tableModel) {
                        column = policyActions.getColumn(columnId, tableModel);
                    } else {
                        column = null;
                    }
                    var path = policyPropertyPathToId.toPath(columnId);
                    var columnName = policyActions.getColumnName(column, path, model, internalModel);
                    attributes.content += '<tr><td>' + escapeHtml(columnName) + '</td><td><strong>{' + path + '}</strong></td></tr>';
                });
                attributes.content += '</tbody></table>';
                attributes.content += '<h3>Policy filters</h3>';
                attributes.content += '<table><tbody>';
                if (lastArgs) {
                    _(policyActions.getFiltersInfo(model, tableModel, internalModel, lastArgs)).each(function (info) {
                        var asText = linkedText.toText(info.label);
                        var parsed = asText.match(/<strong>(.*)<\/strong>:\s*(.*)/);
                        if (parsed.length === 3) {
                            attributes.content += '<tr><td>' + escapeHtml(parsed[1]) + '</td><td><strong>' + escapeHtml(parsed[2]) + '</strong></td></tr>';
                        }
                    });
                }
                attributes.content += '</tbody></table>';
                attributes.content += '<p class="query-view-link"><a href="' + window.location.toString() + '" target="_blank">Click here to see all detections of this type</a></p>';
                attributes.to = sideMenuManager.currentUser().email;
                return attributes;
            },
            generateReportCef: function (model) {
                var attributes = {};
                attributes.raw_cef_extension = _(model.columnsOrderOverride).map(function (columnId) {
                    var path = policyPropertyPathToId.toPath(columnId);
                    return path + '={' + path + '}';
                }).join(' ');
                return attributes;
            },
            generateReportSplunk: function (model, internalModel, tableModel) {
                var attributes = {};
                attributes.json = _(model.columnsOrderOverride).map(function (columnId) {
                    var column;
                    if (tableModel) {
                        column = policyActions.getColumn(columnId, tableModel);
                    } else {
                        column = null;
                    }
                    var path = policyPropertyPathToId.toPath(columnId);
                    var columnName = policyActions.getColumnName(column, path, model, internalModel);
                    return columnName + '={' + path + '};';
                }).join('\n');
                return attributes;
            },
            getColumn: function (columnId, tableModel) {
                return _(tableModel.columns).find(function (column) {
                    return column.id == columnId;
                });
            },
            getColumnName: function (column, path, model, internalModel) {
                if (!column) {
                    if (model.columnNames[path]) {
                        return model.columnNames[path];
                    } else {
                        var nodeId = _(policyPropertyToNodes(path)).last();
                        var property = internalModel.conditionProperties.properties[nodeId];
                        return property.label;
                    }
                }
                return model.columnNames[column.path] || column.text;
            },
            getFiltersInfo: function (model, tableModel, internalModel, lastArgs) {
                if (_(tableModel).isNull()) {
                    return [];
                }
                return _(lastArgs.columnsFilters).chain().map(function (columnData, columnId) {
                    function makeRemoveButton(filterId) {
                        return '#' + JSON.stringify({
                            display: 'text',
                            'class': 'fa fa-times blue-text cursor-pointer condition-remove hide-on-system',
                            clickEvent: {
                                name: 'remove-filter',
                                columnId: columnId,
                                filterId: filterId
                            },
                            tooltip: 'Remove'
                        });
                    }
                    var column = policyActions.getColumn(columnId, tableModel);
                    var path = policyPropertyPathToId.toPath(columnId);
                    var nodeId = policyPropertyParser(path).nodeId;
                    var property = internalModel.conditionProperties.properties[nodeId];
                    var columnName = policyActions.getColumnName(column, path, model, internalModel);
                    var mappedConditions = _(columnData).map(function (value, filterId) {
                        return [
                            value,
                            filterId
                        ];
                    });
                    var notNullConditions = _(mappedConditions).filter(function (c) {
                        return _(c[0].notNull).isUndefined();
                    });
                    var nullConditions = _(mappedConditions).filter(function (c) {
                        return c[0].notNull === true;
                    });
                    var notEmpty = _(nullConditions).map(function (c) {
                        return 'not empty ' + makeRemoveButton(c[1]);
                    }).join('');
                    return {
                        path: path,
                        columnData: columnData,
                        label: '#' + JSON.stringify({
                            display: 'text',
                            text: columnName + ': ',
                            asText: '<strong>' + columnName + '</strong>: ',
                            tooltip: path,
                            'class': 'bold-text'
                        }) + _(notNullConditions).map(function (c, cIdx) {
                            var value = c[0];
                            var filterId = c[1];
                            var last = cIdx == notNullConditions.length - 1 && !nullConditions.length;
                            var removeButton = makeRemoveButton(filterId);
                            var operatorText = '';
                            if (value.not) {
                                operatorText += 'not ';
                            }
                            if (value.aggregatedOperator) {
                                operatorText += value.aggregatedOperator + ' ';
                            }
                            operatorText += value.operatorLabel + ' ';
                            var text = [];
                            if (value.dataLabel) {
                                var label = value.dataLabel;
                                if (!_(label).isArray()) {
                                    label = [label];
                                }
                                text = label;
                            } else if (_(value.data).isArray()) {
                                text = _(value.data).map(function (id) {
                                    var variants = property.variants || {};
                                    var found = _(variants).find(function (v) {
                                        return v.id == id;
                                    });
                                    return found ? found.label : id;
                                });
                            } else if (_(value.data).isObject()) {
                                if (!_(value.data.first).isUndefined() && !_(value.data.second).isUndefined()) {
                                    text.push(value.data.first + ' and ' + value.data.second);
                                }
                            } else {
                                text.push(value.data);
                            }
                            return '#' + JSON.stringify({
                                display: 'text',
                                text: operatorText
                            }) + _(text).map(function (t, idx) {
                                var postfix = ',';
                                if (idx == text.length - 1) {
                                    postfix = '';
                                }
                                return '#' + JSON.stringify({
                                    display: 'text',
                                    text: t + postfix + ' ',
                                    asText: t + postfix + (last ? '' : ';'),
                                    'class': 'bold-text'
                                });
                            }).join('') + removeButton;
                        }).join('') + notEmpty
                    };
                }).filter(_.isObject).value();
            },
            addAction: function (type, model, internalModel, tableModel) {
                tableModel = tableModel || {};
                var attributes = {};
                var lastArgs = {
                    columnsFilters: policyConditionToFiltersConverter.toFilters(model.includeCondition),
                    facets: undefined,
                    filter: '',
                    limit: 20,
                    offset: 0,
                    ordering: {}
                };
                if (type.id == 'send_mail') {
                    attributes = policyActions.generateSendMail(model, internalModel, tableModel, lastArgs);
                } else if (type.id == 'report_cef_over_syslog') {
                    attributes = policyActions.generateReportCef(model);
                } else if (type.id == 'report_event_to_splunk') {
                    attributes = policyActions.generateReportSplunk(model, internalModel, tableModel);
                }
                return {
                    id: uuid.random(),
                    attributes: attributes,
                    tags: {},
                    name: type.id
                };
            },
            getActionType: function (action, model, internalModel) {
                var actionTypes = internalModel.actionTypes[model.entityType];
                return _(actionTypes).find(function (type) {
                    return type.id == action.name;
                });
            },
            policyActionConfigureDialog: function (action, params, actionType, actionCanHaveTags, model, internalModel) {
                return modals.params([{
                        params: params,
                        lastPage: true,
                        getProperties: _.memoize(remediationProperties(internalModel.conditionProperties.properties))
                    }], actionType.label, actionType.size, { noDataLabel: actionType.confirm }).then(function (data) {
                    var attributes = _(data).omit('_label', '_not_run_backwards');
                    if (actionCanHaveTags && actionTagsProcessor.getProperties(attributes).length < 1) {
                        return modals.alert('Action should have some tags. Please select one.', {
                            title: 'Error',
                            keyboard: false,
                            backdrop: 'static',
                            disableCloseX: true
                        }).then(function () {
                            _(params).each(function (param) {
                                param.data = data[param.id];
                            });
                            return policyActions.policyActionConfigureDialog(action, params, actionType, actionCanHaveTags, model, internalModel);
                        });
                    }
                    action.label = data._label;
                    model.not_run_backwards = data._not_run_backwards;
                    _(attributes).each(function (param, id) {
                        action.attributes[id] = param;
                    });
                    return action;
                });
            },
            showConfigurePopup: function (action, model, internalModel) {
                var actionCanHaveTags = false;
                var actionType = policyActions.getActionType(action, model, internalModel);
                var params = _(actionType.attributes).chain().filter(function (param) {
                    return _(param.label).isString();
                }).map(function (param) {
                    actionCanHaveTags = actionCanHaveTags || param.type === 'property-string' || param.type === 'property' || param.type === 'property-email-body' || param.type === 'cef-items';
                    return $.extend(true, {}, param, { data: action.attributes[param.id] });
                }).value();
                params.splice(0, 0, {
                    label: 'Action name',
                    id: '_label',
                    data: action.label || actionType.label,
                    type: 'string'
                });
                params.push({
                    label: 'Run on new items only (*)',
                    labelTip: {
                        content: { text: 'Query wise property, applicable to all actions' },
                        position: {
                            my: 'bottom left',
                            at: 'top center'
                        }
                    },
                    id: '_not_run_backwards',
                    data: model.not_run_backwards,
                    type: 'boolean'
                });
                return policyActions.policyActionConfigureDialog(action, params, actionType, actionCanHaveTags, model, internalModel);
            },
            removeColumn: function (path, model, tableModel, buttons) {
                var columnId = policyPropertyPathToId.toId(path);
                model.columnsOrderOverride = _(model.columnsOrderOverride).filter(function (fullId) {
                    return columnId != fullId;
                });
                if (model.columnsToShow[path].resolve) {
                    model.columnsToShow[path].order = null;
                    delete model.columnsToShow[path].sortIndex;
                    delete model.columnsToShow[path].sortDirection;
                } else {
                    delete model.columnsToShow[path];
                }
                tableModel.columnsOrder = tableOptions.columnsOrder = model.columnsOrderOverride;
                if (buttons) {
                    buttons.policyColumnsPick.model[path] = false;
                }
            },
            generateBody: function (setNotSystem, model, internalModel) {
                var saas = model.saas;
                delete model.saas;
                return {
                    'policy_status': internalModel.policy_status,
                    'policy_data': model,
                    'scheduled': internalModel.scheduled,
                    'old_policy_data': internalModel.oldPolicy,
                    'context': {
                        'saas': saas,
                        'layout': model.layout
                    },
                    'hidden': internalModel.temporary,
                    'temporary': internalModel.temporary,
                    'system': setNotSystem ? false : internalModel.system
                };
            },
            updatePolicy: function (id, model, internalModel) {
                internalModel.temporary = false;
                model.basePolicyId = undefined;
                return policyDao.update(id, policyActions.generateBody(undefined, model, internalModel));
            }
        };
        return policyActions;
    }]);
}());